export const getSatelliteMapStyles = (key: string, awsRegion: string) => {
  return {
    version: 8,
    name: 'AmazonLocation-Satellite',
    metadata: {
      version: '2.0.1',
    },
    sources: {
      awsImagery: {
        attribution:
          '© \u003Ca href=\'https://docs.aws.amazon.com/location/latest/developerguide/data-attribution.html\'\u003EAWS\u003C/a\u003E, \u003Ca href=\'https://legal.here.com/en-gb/terms/general-content-supplier-terms-and-notices\'\u003EHERE\u003C/a\u003E',
        maxzoom: 19,
        minzoom: 0,
        tiles: [
          `https://maps.geo.${awsRegion}.amazonaws.com/v2/tiles/raster.satellite/{z}/{x}/{y}?key=${key}`,
        ],
        type: 'raster',
      },
    },

    sprite: `https://maps.geo.${awsRegion}.amazonaws.com/v2/styles/2_1_0/Hybrid/Light/Default/sprites/sprites`,
    glyphs: `https://maps.geo.${awsRegion}.amazonaws.com/v2/glyphs/{fontstack}/{range}.pbf`,
    layers: [
      {
        id: 'awsImagery',
        layout: {
          visibility: 'visible',
        },
        source: 'awsImagery',
        type: 'raster',
      },
      /* {
      'filter': [
        'all',
        [
          'match',
          [
            'get',
            'kind_detail'
          ],
          [
            'city',
            'locality',
            'town',
            'village',
            'hamlet'
          ],
          true,
          false
        ],
        [
          'all',
          [
            '!=',
            [
              'get',
              'kind'
            ],
            'unrecognized_locality'
          ],
          [
            '==',
            [
              'get',
              'kind'
            ],
            'locality'
          ]
        ],
        [
          '<',
          [
            'get',
            'population'
          ],
          1000000
        ],
        [
          'step',
          [
            'zoom'
          ],
          [
            '>=',
            [
              'get',
              'population'
            ],
            500
          ],
          8,
          [
            '>=',
            [
              'get',
              'population'
            ],
            350
          ],
          10,
          [
            '>=',
            [
              'get',
              'population'
            ],
            1000
          ],
          11,
          [
            '>=',
            [
              'get',
              'population'
            ],
            500
          ],
          12,
          [
            '>=',
            [
              'get',
              'population'
            ],
            1000
          ]
        ],
        [
          '==',
          [
            'geometry-type'
          ],
          'Point'
        ]
      ],
      'id': 'place_label_locality_settlement',
      'layout': {
        'icon-anchor': [
          'case',
          [
            '>=',
            [
              'get',
              'population'
            ],
            1200000
          ],
          'top',
          'center'
        ],
        'icon-image': [
          'step',
          [
            'zoom'
          ],
          [
            'case',
            [
              'has',
              'country_capital'
            ],
            'citydot-open',
            'citydot'
          ],
          8,
          [
            'case',
            [
              'all',
              [
                'has',
                'country_capital'
              ],
              [
                '>',
                [
                  'get',
                  'population'
                ],
                100000
              ]
            ],
            'citydot-open',
            [
              'all',
              [
                'has',
                'country_capital'
              ],
              [
                '==',
                [
                  'get',
                  'population'
                ],
                100000
              ]
            ],
            'citydot-open_lowrank',
            [
              '>',
              [
                'get',
                'population'
              ],
              100000
            ],
            'citydot',
            'citydot_lowrank'
          ]
        ],
        'symbol-sort-key': [
          '*',
          -1,
          [
            'get',
            'population'
          ]
        ],
        'text-field': [
          'coalesce',
          [
            'get',
            'name:en'
          ],
          [
            'get',
            'name'
          ]
        ],
        'text-font': [
          'Amazon Ember Regular,Noto Sans Regular'
        ],
        'text-justify': 'auto',
        'text-line-height': 1,
        'text-padding': 8,
        'text-radial-offset': 0.1,
        'text-size': [
          'interpolate',
          [
            'linear'
          ],
          [
            'zoom'
          ],
          9,
          11,
          10,
          [
            'case',
            [
              '>=',
              [
                'get',
                'population'
              ],
              200
            ],
            13,
            11
          ],
          11,
          [
            'case',
            [
              '>=',
              [
                'get',
                'population'
              ],
              200
            ],
            14,
            [
              '>=',
              [
                'get',
                'population'
              ],
              100
            ],
            13,
            [
              '>=',
              [
                'get',
                'population'
              ],
              50
            ],
            12,
            11
          ],
          14,
          [
            'case',
            [
              '>=',
              [
                'get',
                'population'
              ],
              200
            ],
            15,
            13
          ]
        ],
        'text-variable-anchor': [
          'step',
          [
            'zoom'
          ],
          [
            'literal',
            [
              'bottom',
              'bottom-right',
              'bottom-left',
              'top-left',
              'top-right'
            ]
          ],
          9,
          [
            'literal',
            [
              'center'
            ]
          ]
        ]
      },
      'maxzoom': 16,
      'minzoom': 7,
      'paint': {
        'icon-opacity': [
          'interpolate',
          [
            'linear'
          ],
          [
            'zoom'
          ],
          3,
          1,
          8.5,
          1,
          9,
          0
        ],
        'text-color': [
          'interpolate',
          [
            'linear'
          ],
          [
            'zoom'
          ],
          9,
          'hsl(228, 0%, 42%)',
          10,
          'hsl(228, 0%, 42%)',
          11,
          [
            'case',
            [
              '>=',
              [
                'get',
                'population'
              ],
              20000
            ],
            'hsl(228, 0%, 39%)',
            'hsl(228, 0%, 42%)'
          ],
          12,
          [
            'case',
            [
              '>=',
              [
                'get',
                'population'
              ],
              10000
            ],
            'hsl(228, 0%, 39%)',
            'hsl(228, 0%, 42%)'
          ],
          13,
          'hsl(228, 0%, 39%)'
        ],
        'text-halo-blur': 0.25,
        'text-halo-color': 'hsl(228, 0%, 97%)',
        'text-halo-width': [
          'case',
          [
            '>=',
            [
              'get',
              'population'
            ],
            10000
          ],
          1.25,
          1
        ]
      },
      'source': 'aws',
      'source-layer': 'places',
      'type': 'symbol'
    },
    {
      'filter': [
        'all',
        [
          '==',
          [
            'get',
            'kind'
          ],
          'minor_road'
        ],
        [
          '!=',
          [
            'get',
            'kind_detail'
          ],
          'service'
        ],
        [
          '!=',
          [
            'get',
            'private'
          ],
          true
        ],
        [
          '!',
          [
            'has',
            'is_link'
          ]
        ],
        [
          '==',
          [
            'geometry-type'
          ],
          'LineString'
        ]
      ],
      'id': 'road_label_small',
      'layout': {
        'symbol-placement': 'line',
        'symbol-spacing': 300,
        'text-field': [
          'coalesce',
          [
            'get',
            'name:en'
          ],
          [
            'get',
            'name'
          ]
        ],
        'text-font': [
          'Amazon Ember Condensed RC Regular,Noto Sans Regular'
        ],
        'text-max-angle': 40,
        'text-offset': [
          'interpolate',
          [
            'linear'
          ],
          [
            'zoom'
          ],
          13,
          [
            'literal',
            [
              0,
              -0.3
            ]
          ],
          14,
          [
            'literal',
            [
              0,
              0.02
            ]
          ]
        ],
        'text-padding': 1,
        'text-pitch-alignment': 'viewport',
        'text-size': [
          'interpolate',
          [
            'linear'
          ],
          [
            'zoom'
          ],
          13,
          8,
          18,
          16,
          22,
          24
        ],
        'text-transform': 'uppercase'
      },
      'minzoom': 13,
      'paint': {
        'text-color': 'hsl(228, 0%, 50%)',
        'text-halo-blur': 0.75,
        'text-halo-color': 'hsl(228, 0%, 92%)',
        'text-halo-width': 2
      },
      'source': 'aws',
      'source-layer': 'roads',
      'type': 'symbol'
    }, */
    ],
    created: '0001-01-01T00:00:00Z',
    modified: '0001-01-01T00:00:00Z',
    id: 'aws-satellite-2.0.1',
  };
};
